import React from "react";
import {IProtocolStep, IRestStep} from "../../../types/protocol";
import {IRestStepDefinition} from "../../../types/protocolDefinitions";
import {StepDurationField} from "../fields/StepDurationField";
import classes from "../StepView.module.css";
import {DeepPartial} from "@/utils/types/DeepPartial";
import {TWorkflow} from "../StepView";

/** Union type for Rest steps (both execution and planning modes) */
type RestStep = IRestStep | IRestStepDefinition;

export interface RestStepViewProps {
    step: RestStep;
    onChange: (updates: DeepPartial<RestStep>) => void;
    workflow?: TWorkflow;
}

/**
 * View component for rest event steps.
 * This is the primary rendering for rest steps in all contexts.
 * Used in protocol execution, planning, and review modes.
 */
export const RestStepView: React.FC<RestStepViewProps> = ({
    step,
    onChange,
    workflow = "session",
}) => {
    const isReadOnly = workflow === "review";

    return (
        <div style={{display: "flex", flexDirection: "column", width: "100%"}}>
            <div style={{display: "flex", gap: "1em", alignItems: "end"}}>
                <div className={classes.durationField}>
                    <StepDurationField
                        duration={step.duration}
                        onChange={(duration) => onChange({duration})}
                        w={80}
                        disabled={isReadOnly}
                    />
                </div>
            </div>
        </div>
    );
};